module.exports = require('./helpers/bundle-url').getBundleURL('aw0Im') + "logo-dark.a922e36b.svg";